import {Step} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/step';
import {
  TestPassState,
  TestQuestion,
  TestResponse,
  TestResponseCommands
} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/models';
import {Observable} from 'rxjs';
import {
  CheckItemsManager
} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/check-items-manager';
import {Role} from '@app/modules/shared/data/constants';

export class TabletCheckManager extends CheckItemsManager {
  icon = 'tablet-g';
  name = 'Tablet';
  testStatus;

  constructor(userRole: Role) {
    super(userRole);
    this.steps.push(new Wacom());
  }
}

export class Wacom extends Step {
  name = 'Wacom';
  title = 'Checking WACOM tablet setup';

  constructor() {
    super(true);
    this.testQuestion = new TestQuestion('Please check if your wacom pen works.\n',
      [{text: 'It doesn\'t work', value: 'no', color: 'blue', isBlock: false,isDisabled:false}, {
        text: 'It works!',
        value: 'yes',
        color: 'blue',
        isBlock: false,
        isDisabled:false
      }],
    );
  }
  doRunStep() {
    return new Observable<TestResponse>(subscriber => {
      if (this.stepPayload === 'no') {
        this.testResult.status = TestPassState.FAILED;
        this.testResult.errorMassage = 'You will not be able to write on the board properly without a working Wacom tablet. ' +
          'Please consult the classroom guide or ask tech support for help, then retry this step. ' +
          'If you have done everything currently possible, skip this step.';
        this.testResult.text = 'My wacom tablet is not ok';
        this.testStatus='NO';
        subscriber.next(new TestResponse(TestResponseCommands.SHOW_ERROR));
      } else {
        this.testResult.status = TestPassState.PASSED;
        this.testResult.text = 'My wacom tablet is ok';
        this.testStatus='OK';
        subscriber.next(new TestResponse(TestResponseCommands.NEXT));
      }
    });
  }
}
